<template>
  <Row id="SelfLeave">
    <Col :span="24" class="title">
      <TypographyTitle>{{$t('nav.name.SelfLeaveManage')}}</TypographyTitle>
    </Col>
    <Col :span="24" class="content">
      <Row :gutter="[16,32]">
        <Col :span="24" >
          <Form :model="searchForm">
            <Row :gutter="30">
             
              <!-- <Col :xs="24" :sm="8">
                <FormItem :label="$t('leave.name.search')" name="search">
                  <Input :placeholder="$t('leave.name.search')" v-model:value="searchForm.search"></Input>
                </FormItem>
              </Col> -->
              <!-- <Col :xs="24" :sm="8">
                <FormItem :label="$t('public.field.status')">
                  <Select v-model:value="searchForm.status" :placeholder="$t('public.placeholder.please_select')">
                    <SelectOption :value="0">{{ $t('public.placeholder.please_select') }}</SelectOption>
                    <SelectOption :value="1">{{ $t('public.status.1') }}</SelectOption>
                    <SelectOption :value="2">{{ $t('public.status.2') }}</SelectOption>
                  </Select>
                </FormItem>
              </Col> -->
              <Col :xs="24" :sm="5">
                    <FormItem :label="$t('leave.field.id_lea_typ')" name="idLeaTyp">
                      <!--关联表的下拉选择-->
                      <Select
                              v-model:value="searchForm.idLeaTyp"
                              :placeholder="$t('leave.validate.required.id_lea_typ')"
                              :dropdownStyle="{ zIndex: 9999999950 }"
                      >
                                            <SelectOption :value="null">{{ $t('attendance.name.select_all') }}</SelectOption>
                          <SelectOption :key="sk" v-for="(item,sk) in selectList['leaveTypeList']" :value="item['idLeaTyp']">{{ item['leaveTypeName'] }}</SelectOption>
                      </Select>
                  </FormItem>
                </Col>
                <Col :xs="24" :sm="9">
                <FormItem :label="$t('attendance.name.dateRange')" name="dateRange">
                  <RangePicker :allowClear="false" v-model:value="rangePickerDate" @change="rangeChange"/>
                </FormItem>
              </Col>
              <Col span="10">
                    <FormItem :label="$t('leave.field.status')" name="status">
                      <Select
                              v-model:value="searchForm.status"
                              :placeholder="$t('leave.validate.required.status')"
                              :dropdownStyle="{ zIndex: 9999999950 }"
                      >
                      <SelectOption :value="null">{{ $t('attendance.name.select_all') }}</SelectOption>
                          <SelectOption :key="sk" v-for="(item,sk) in selectList['statusList']" :value="item['value']">{{ item['label'] }}</SelectOption>
                      </Select>
                  </FormItem>
                </Col>
              <Col :xs="24" :sm="8" class="text-right">
                <Button type="primary" @click="search_submit">{{$t('public.name.search')}}</Button>&nbsp;
                <Button @click="search_reset">{{$t('public.name.reset')}}</Button>
              </Col>
            </Row>
          </Form>
        </Col>
        <Col :span="24" v-if="remainingVacation">
        
          <span style="font-size:16pt;">{{$t('employee.field.name_tw')}} :  {{remainingVacation.employeeNameTw}}</span>&nbsp;&nbsp;&nbsp;&nbsp;
                <span style="font-size:16pt;">{{$t('department.field.name')}} :  {{remainingVacation.departmentName}}</span>&nbsp;&nbsp;&nbsp;&nbsp;
                <!-- <span style="font-size:16pt;">{{$t('remainingVacation.field.remaining_annual_leave_days')}} :  {{remainingVacation.remainingAnnualLeaveDays}}</span>&nbsp;&nbsp;&nbsp;&nbsp;
                <span style="font-size:16pt;">{{$t('remainingVacation.field.remaining_maternity_leave_days')}} :  {{remainingVacation.remainingMaternityLeaveDays}}</span>&nbsp;&nbsp;&nbsp;&nbsp;
                <span style="font-size:16pt;">{{$t('remainingVacation.field.remaining_paternity_leave_days')}} :  {{remainingVacation.remainingPaternityLeaveDays}}</span>&nbsp;&nbsp;&nbsp;&nbsp;
                <span style="font-size:16pt;">{{$t('remainingVacation.field.remaining_sick_leave_days')}} :  {{remainingVacation.remainingSickLeaveDays}}</span> -->
        
        </Col>
        <Col :span="24" v-if="remainingVacation">
          <Table :columns="remainingVacationColumns" :dataSource="remainingVacationList" :scroll="{ x: true }" :pagination="false">
          </Table>
        </Col>
        <Col :span="24">
        <Table :columns="columns" :dataSource="list" :scroll="{ x: true }" rowKey="idLea" :loading="loading" :pagination="tablePagination" @change="chang_page">
            <template #actionTitle>
              <span>
                {{$t("public.table.action")}}
                <Button v-if="checkPermission('SelfLeaveManage.Add')" type="primary" size="small" shape="circle" @click="add()">
                  <PlusOutlined />
                </Button>
              </span>
            </template>
            <template #action="{text,record}">
              <div>
                <!-- <div class="pc-display">
                  <Button type="default" size="small" @click="detail(text)">{{$t("public.name.detail")}}</Button>
                  <span>&nbsp;</span>
                  <Button v-if="checkPermission('LeaveManage.Edit') && !record.approverId" type="primary" size="small" @click="edit(text)">{{$t("public.name.edit")}}</Button>
                  <span>&nbsp;</span>
                  <Button v-if="checkPermission('LeaveManage.Delete')" type="primary" danger size="small" @click="del(text.idLea)">{{$t("public.name.del")}}</Button>
                  <span>&nbsp;</span>
                  <Button v-if="checkPermission('LeaveManage.Approve') && !record.approverId" type="primary" size="small" @click="approve(text)">{{$t("leave.name.approve")}}</Button>
                </div> -->
                <Dropdown :trigger="['click']">
                  <template #overlay>
                    <Menu>
                      <MenuItem @click="detail(text)">{{$t('public.name.detail')}}</MenuItem>
                      <MenuItem v-if="checkPermission('SelfLeaveManage.Edit') && record.status == 0" @click="edit(text)">{{$t('public.name.edit')}}</MenuItem>
                      <MenuItem v-if="checkPermission('SelfLeaveManage.Delete') && record.status == 0" danger @click="del(text.idLea)">{{$t('public.name.del')}}</MenuItem>
                      <MenuItem v-if="checkPermission('SelfLeaveManage.Send') && record.status == 0" danger @click="send(text.idLea)">{{$t('public.name.send')}}</MenuItem>
                    </Menu>
                  </template>
                  <Button size="small">
                    {{$t("public.name.more")}}
                    <DownOutlined />
                  </Button>
                </Dropdown>
              </div>
            </template>
          </Table>
        </Col>
      </Row>
    </Col>
    <LeaveDetail ref="refLeaveDetail"></LeaveDetail>
    <SelfLeaveEdit ref="refSelfLeaveEdit" @updateList="get_list"></SelfLeaveEdit>
  </Row>
</template>

<script>
import { createVNode } from "vue";
import { Row, Col, Table, Typography, Tag, Button, Dropdown, Menu, Modal, Form, Input, Select, message,RangePicker,Card } from "ant-design-vue";
import { DownOutlined, ExclamationCircleOutlined, PlusOutlined } from "@ant-design/icons-vue";
import { LeaveList } from "@/api/LeaveList";
import { LeaveDelete } from "@/api/LeaveDelete"
import { LeaveSend } from "@/api/LeaveSend"
import { LeaveTypeListAll } from "@/api/LeaveTypeListAll"
import { RemainingGetByIdEmp } from "@/api/RemainingGetByIdEmp";
import { LeaveGetHistoryLeave } from "@/api/LeaveGetHistoryLeave";
import { AnnualLeavePlanGetById } from "@/api/AnnualLeavePlanGetById";
import LeaveDetail from "@/components/Home/LeaveDetail";
import SelfLeaveEdit from "@/components/Home/SelfLeaveEdit";
import moment from "moment";

export default {
  name: "SelfLeaveManage",
  components: {
    Row,
    Col,
    Table,
    Form,
    FormItem: Form.Item,
    TypographyTitle: Typography.Title,
    Tag,
    Button,
    Input,
    Select,
    SelectOption: Select.Option,
    Dropdown,
    DownOutlined,
    PlusOutlined,
    ExclamationCircleOutlined,
    Menu,
    MenuItem: Menu.Item,
    LeaveDetail,
    SelfLeaveEdit,
    RangePicker,
    Card,
  },
  data() {
    return {
      rangePickerDate:[null,null],
      remainingVacation:null,
      searchForm: {
        idEmp: this.$store.getters.getId,
        idLeaTyp: null,
        startDate: null,
        endDate: null,
        status: null,
      },
      tablePagination: {
        pageSizeOptions: ["10", "20", "50", "100"],
        showSizeChanger: true,
        current: 1,
        pageSize: 10,
        total: 0,
      },
      loading: false,
      list: [],
      columns: [
          { title: this.$t("leave.table.id_lea"), fixed: "left", dataIndex: "idLea", key: "idLea" },
          { title: this.$t("leave.table.id_emp"), dataIndex: "employeeNickName", key: "employeeNickName" },
          { title: this.$t("leave.table.id_lea_typ"), dataIndex: "leaveTypeLeaveTypeName", key: "leaveTypeLeaveTypeName" },
          // { title: this.$t("leave.table.leave_type"), dataIndex: "leaveType", key: "leaveType", customRender: ({text}) =>{
          //     return this.selectList.leaveTypeList.find(item=>item.value===text).label
          //   }
          // },
          { title: this.$t("leave.table.start_time"), dataIndex: "startTime", key: "startTime", customRender: ({text,record}) =>{
              // if(record.leaveType === 2 || record.leaveType === 3 || record.leaveType === 4){
                return moment(text).format('YYYY-MM-DD')
              // }else {
              //   return moment(text).format('YYYY-MM-DD HH:mm:ss')
              // }
            }
          },
          { title: this.$t("leave.table.end_time"), dataIndex: "endTime", key: "endTime", customRender: ({text,record}) =>{
              // if(record.leaveType === 2 || record.leaveType === 3 || record.leaveType === 4){
                return moment(text).format('YYYY-MM-DD')
              // }else {
              //   return moment(text).format('YYYY-MM-DD HH:mm:ss')
              // }
            }
          },
          { title: this.$t("leave.table.duration"), dataIndex: "duration", key: "duration", customRender: ({text,record}) =>{
              // var days =  Math.floor(text/480);
              // var hours =  Math.floor(text%480/60);
              // var minutes =  text%60;
              // var result = '';
              // if(days !== 0){
              //   result = days + '天';
              // }
              // if(hours !== 0){
              //   result = result + hours + "小時"
              // }
              // if(minutes !== 0){
              //   result = result + minutes + "分鐘"
              // }
              // return result;
              return text + '天'
            }
          },
          // { title: this.$t("leave.table.reason"), dataIndex: "reason", key: "reason" },
          // { title: this.$t("leave.table.picture_url"), dataIndex: "pictureUrl", key: "pictureUrl" },
          { title: this.$t("leave.table.status"), dataIndex: "status", key: "status", customRender: ({text,record}) =>{
              return this.selectList.statusList.find(item=>item.value===text).label
            }
          },
          { title: this.$t("leave.table.approver_id"), dataIndex: "approverNickName", key: "approverNickName" },
          { title: this.$t("leave.table.approve_time"), dataIndex: "approveTime", key: "approveTime" },
          // { title: this.$t("leave.table.cc"), dataIndex: "cc", key: "cc" },
          // { title: this.$t("leave.table.remark"), dataIndex: "remark", key: "remark" },
          { title: this.$t("leave.table.approver2_id"), dataIndex: "approver2NickName", key: "approver2NickName" },
          { title: this.$t("leave.table.approve2_time"), dataIndex: "approve2Time", key: "approve2Time" },
	        { title: this.$t("leave.table.submit_time"), dataIndex: "submitTime", key: "submitTime", customRender: ({text}) =>{return moment(text).format('YYYY-MM-DD HH:mm:ss')}},
          { title: this.$t("leave.table.time_frame"), dataIndex: "timeFrame", key: "timeFrame", customRender: ({text}) =>{
              if(text){
                return this.selectList.timeFrameList.find(item=>item.value===text).label
              }    
            }
          },
        { key: "action", fixed: "right", slots: { title: "actionTitle", customRender: "action" } },
      ],
      remainingVacationList:[],
      remainingVacationColumns:[
          { title: this.$t("remainingVacation.table.vacation_type"), dataIndex: "vacationType", key: "vacationType" },
          { title: this.$t("remainingVacation.table.vacation"), dataIndex: "vacation", key: "vacation" },
          { title: this.$t("remainingVacation.table.used_vacation"), dataIndex: "usedVacation", key: "usedVacation" },
          { title: this.$t("remainingVacation.table.remaining_vacation"), dataIndex: "remainingVacation", key: "remainingVacation" },

          
      ],
      selectList:{
        employeeList: [],
        leaveTypeList: [],
        // leaveTypeList: [{value: 1,label: '調休'},{value: 2,label: '年假'},{value: 3,label: '產假'},{value: 4,label: '侍產假'},{value: 5,label: '事假'},{value: 6,label: '病假'},{value: 7,label: '婚假'}],
        statusList: [{value: 0,label: '待發送'},{value: 1,label: '待審批'},{value: 2,label: '已拒絕'},{value: 3,label: '已通過'}],
	      timeFrameList: [{value: 1,label: 'AM'},{value: 2,label: 'PM'}],
      }
    };
  },
  methods: {
    chang_page(pagination) {
      this.tablePagination = pagination;
      this.get_list();
    },
    get_list() {
      this.loading = true;
      const api = new LeaveList();
      const getData = {
        page: this.tablePagination.current,
        limit: this.tablePagination.pageSize,
      }
      if (this.searchForm.search != "") getData.search = this.searchForm.search
      if (this.searchForm.idLeaTyp != "") getData.idLeaTyp = this.searchForm.idLeaTyp
      if (this.searchForm.startDate != "") getData.startDate = this.searchForm.startDate
      if (this.searchForm.endDate != "") getData.endDate = this.searchForm.endDate
      getData.status = this.searchForm.status
      getData.idEmp = this.searchForm.idEmp
      // if (this.searchForm.order != "") getData.order = this.searchForm.order
      api
        .get(getData)
        .then((response) => {
          this.loading = false;
          if (0 === parseInt(response.data.code)) {
            const dataTmp = response.data.data;
            this.tablePagination.current = parseInt(dataTmp.current);
            this.tablePagination.pageSize = parseInt(dataTmp.pageSize);
            this.tablePagination.total = parseInt(dataTmp.total);
            this.list = dataTmp.data;
            //如果當前處於不是第一頁，但是又沒有數據的情況，則把頁面設置為1，並重新請求
            if(this.list.length == 0 && this.tablePagination.current != 1){
              this.tablePagination.current = 1;
              this.get_list();
            }
          } else {
            this.list = [];
          }
        });
    },
    add() {
      this.$refs.refSelfLeaveEdit.addShow();
    },
    detail(obj) {
      this.$refs.refLeaveDetail.detailShow(obj);
    },
    edit(obj) {
      this.$refs.refSelfLeaveEdit.editShow(obj);
    },
    del(idLea) {
      Modal.confirm({
        title: this.$t("public.name.are_you_sure_delete") + "?",
        content: this.$t("public.name.action_cannot_resumed"),
        icon: createVNode(ExclamationCircleOutlined),
        okText: this.$t("public.name.yes"),
        okType: "danger",
        cancelText: this.$t("public.name.no"),
        onOk: () => {
          const api = new LeaveDelete();
          api.post({ idLea: idLea }).then((response) => {
            if (0 === parseInt(response.data.code)) {
              this.get_list();
              message.success(response.data.msg);
            } else {
              message.error(response.data.msg);
            }
          });
        },
      });
    },
    send(idLea) {
      Modal.confirm({
        title: this.$t("leave.name.are_you_sure_send") + "?",
        content: this.$t("public.name.action_cannot_resumed"),
        icon: createVNode(ExclamationCircleOutlined),
        okText: this.$t("public.name.yes"),
        okType: "danger",
        cancelText: this.$t("public.name.no"),
        onOk: () => {
          const api = new LeaveSend();
          api.post({ idLea: idLea }).then((response) => {
            if (0 === parseInt(response.data.code)) {
              this.get_list();
              message.success(response.data.msg);
            } else {
              message.error(response.data.msg);
            }
          });
        },
      });
    },
    getLeaveTypeList() {
      const api = new LeaveTypeListAll();
      api.get().then((response) => {
        if (0 == parseInt(response.data.code)) {
            this.selectList.leaveTypeList = response.data.data;
        } else {
            message.error(response.data.msg);
        }
      });
    },
    getRemainingVacation() {
      let api = new RemainingGetByIdEmp();
      api
        .get({
          idEmp: this.$store.getters.getId,
        })
        .then((response, any) => {
          if (0 == parseInt(response.data.code)) {
            this.remainingVacation = response.data.data;
            let historyLeaveApi = new LeaveGetHistoryLeave();
            historyLeaveApi
            .get({
              idEmp: this.$store.getters.getId,
              startDate: moment().startOf('year').format('YYYY-MM-DD'),
              endDate: moment().endOf('year').format('YYYY-MM-DD'),
            })
            .then((rs, any) => {

              // let annualLeavePlanGetByIdApi = new AnnualLeavePlanGetById();
              // annualLeavePlanGetByIdApi.get({
              //   idAnnLeaPla:1
              // }).then((rs1, any) => {
                
                //已用年假
              let usedAnnualLeaveDays = 0;
              rs.data.data.forEach(item => {
                if(item.idLeaTyp == 1 && item.status == 3){
                  usedAnnualLeaveDays += item.duration;
                }
              });
              //已获批但未放
              let usedAnnualLeaveDaysNotUsed = 0;
              rs.data.data.forEach(item => {
                if(item.idLeaTyp == 1 && item.status == 3 && moment(item.startTime).diff(moment(),"days") >= 0){
                  usedAnnualLeaveDaysNotUsed += item.duration;
                }
              });

              //拼湊表格的值
              this.remainingVacationList.push({
                vacationType:"Annual Leave(年假)",
                vacation:(response.data.data.realAnnualLeaveDays).toFixed(4) + '(' + response.data.data.annualLeaveDays.toFixed(4) + ')',
                usedVacation: usedAnnualLeaveDays.toFixed(4) + '(' + usedAnnualLeaveDaysNotUsed.toFixed(4) + ')',
                remainingVacation:(response.data.data.remainingAnnualLeaveDays).toFixed(4) + '(' + (response.data.data.annualLeaveDays - usedAnnualLeaveDays).toFixed(4) + ')',
              })

              //已用產假
              let usedMaternityLeaveDays = 0;
              rs.data.data.forEach(item => {
                if(item.idLeaTyp == 2 && item.status == 3){
                  usedMaternityLeaveDays += item.duration;
                }
              });
              //已获批產假
              let usedMaternityLeaveDaysNotUsed = 0;
              rs.data.data.forEach(item => {
                if(item.idLeaTyp == 2 && item.status == 3 && moment(item.startTime).diff(moment(),"days") > 0){
                  usedMaternityLeaveDaysNotUsed += item.duration;
                }
              });

              this.remainingVacationList.push({
                vacationType:"Maternity Leave(產假)",
                vacation:(response.data.data.remainingMaternityLeaveDays + usedMaternityLeaveDays).toFixed(4) + '(' + response.data.data.maternityLeaveDays.toFixed(4) + ')',
                usedVacation: usedMaternityLeaveDays.toFixed(4) + '(' + usedMaternityLeaveDaysNotUsed.toFixed(4) + ')',
                remainingVacation:response.data.data.remainingMaternityLeaveDays.toFixed(4) + '(' + response.data.data.maternityLeaveDays.toFixed(4) + ')',
              })

              
                //已用侍產假
              let usedPaternityLeaveDays = 0;
              rs.data.data.forEach(item => {
                if(item.idLeaTyp == 3 && item.status == 3){
                  usedPaternityLeaveDays += item.duration;
                }
              });
              //已获批侍產假
              let usedPaternityLeaveDaysNotUsed = 0;
              rs.data.data.forEach(item => {
                if(item.idLeaTyp == 3 && item.status == 3 && moment(item.startTime).diff(moment(),"days") > 0){
                  usedPaternityLeaveDaysNotUsed += item.duration;
                }
              });

              this.remainingVacationList.push({
                vacationType:"Paternity Leave(侍產假)",
                vacation:(response.data.data.remainingPaternityLeaveDays + usedPaternityLeaveDays).toFixed(4) + '(' + response.data.data.paternityLeaveDays.toFixed(4) + ')',
                usedVacation: usedPaternityLeaveDays.toFixed(4) + '(' + usedPaternityLeaveDaysNotUsed.toFixed(4) + ')',
                remainingVacation:response.data.data.remainingPaternityLeaveDays.toFixed(4) + '(' + response.data.data.paternityLeaveDays.toFixed(4) + ')',
              })

                //病假
              let usedSickLeaveDays = 0;
              rs.data.data.forEach(item => {
                if(item.idLeaTyp == 4 && item.status == 3){
                  usedSickLeaveDays += item.duration;
                }
              });
              //已获批
              let usedSickLeaveDaysNotUsed = 0;
              rs.data.data.forEach(item => {
                if(item.idLeaTyp == 4 && item.status == 3 && moment(item.startTime).diff(moment(),"days") > 0){
                  usedSickLeaveDaysNotUsed += item.duration;
                }
              });

              this.remainingVacationList.push({
                vacationType:"Sick Leave(病假)",
                vacation: '-',
                usedVacation: usedSickLeaveDays.toFixed(4) + '(' + usedSickLeaveDaysNotUsed.toFixed(4) + ')',
                remainingVacation: response.data.data.remainingSickLeaveDays.toFixed(4),
              })

                //生日假
                let usedBirthdayLeaveDays = 0;
              rs.data.data.forEach(item => {
                if(item.idLeaTyp == 5 && item.status == 3){
                  usedBirthdayLeaveDays += item.duration;
                }
              });
              //已获批
              let usedBirthdayLeaveDaysNotUsed = 0;
              rs.data.data.forEach(item => {
                if(item.idLeaTyp == 5 && item.status == 3 && moment(item.startTime).diff(moment(),"days") > 0){
                  usedBirthdayLeaveDaysNotUsed += item.duration;
                }
              });

              this.remainingVacationList.push({
                vacationType:"Birthday Leave(生日假)",
                vacation: '-',
                usedVacation: usedBirthdayLeaveDays.toFixed(4) + '(' + usedBirthdayLeaveDaysNotUsed.toFixed(4) + ')',
                remainingVacation: response.data.data.remainingBirthdayLeaveDays.toFixed(4),
              })



              //開始循壞非系統管控的假期
              this.selectList.leaveTypeList.forEach(item =>{
                let idLeaTyp = item.idLeaTyp;
                if(idLeaTyp < 6){
                  return;
                }
                //普通無薪請假
                let usedLeaveDays = 0;
                rs.data.data.forEach(item => {
                  if(item.idLeaTyp == idLeaTyp && item.status == 3){
                    usedLeaveDays += item.duration;
                  }
                });
                //已获批
                let usedLeaveDaysNotUsed = 0;
                rs.data.data.forEach(item => {
                  if(item.idLeaTyp == idLeaTyp && item.status == 3 && moment(item.startTime).diff(moment(),"days") > 0){
                    usedLeaveDaysNotUsed += item.duration;
                  }
                });

                this.remainingVacationList.push({
                  vacationType: item.leaveTypeNameEn + '(' + item.leaveTypeName + ')',
                  vacation: '-',
                  usedVacation: usedLeaveDays.toFixed(4) + '(' + usedLeaveDaysNotUsed.toFixed(4) + ')',
                  remainingVacation: '-',
                })


              })

              


              

            })

              

            // })

            

          } else {
            message.error(response.data.msg);
          }
        });
    },
    rangeChange(dates){
      this.searchForm.startDate = dates[0].format("YYYY-MM-DD")
      this.searchForm.endDate = dates[1].format("YYYY-MM-DD")
    },
    search_submit() {
      this.get_list()
    },
    search_reset() {
      this.searchForm = {
        idEmp: this.$store.getters.getId,
        idLeaTyp: null,
        startDate: null,
        endDate: null,
        status: null,
      }
      this.rangePickerDate = [null,null];
      this.get_list()
    }
  },
  mounted() {
    this.get_list();
    this.getLeaveTypeList();
    this.getRemainingVacation();
  },
}
</script>

<style lang="less">
@import url("~@/assets/less/home/leave.less");
</style>